import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TreeSelect, Select, DatePicker } from 'antd'

// Constant
import { TEMPLATE } from '../../../../../../../constants';

// Components
import { PrimaryButton } from '../../../../../../../components/Decoration/Button';
import VehiclePlateECUTag from '../../../../../../../components/VehiclePlateECUTag';

// Handlers
import { vehicles_handler } from '../../../../../../../handlers';

// Services Library
import { TIME } from '../../../../../../../services/util';

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../../../services/redux/actions'

// Styles
// import '../../index.css'

const {
    TreeNode,
    SHOW_PARENT
} = TreeSelect;

const {
    dayJSLocalize,
    referenceEndOfDay,
    referenceStartTime,
    referenceEndTime
} = TIME


const {
    VAM_ENTRY_STATUS_TITLE
} = TEMPLATE.VAM

const {
    vehicleECUValidator
} = vehicles_handler

const SearchFields = () => {

    const dispatch = useDispatch()

    const vehicles = useSelector(state => state.containers.v3.vehicles.staticsByID)
    const vamLineTypes = useSelector(state => state.containers.v3.vamLines.typeByVAMLTYIDs)

    const [ submitVal, setSubmitVal ] = useState({
        vids: Object.keys(vehicles),
        startTime: referenceStartTime(),
        endTime: referenceEndTime()
    })

    const handleCalendarDisabledDate = (current) => current && current > referenceEndOfDay()

    const submitFormHDLR = () => {
        const startTime = submitVal.startTime?.utc().valueOf()
        const endTime = submitVal.endTime?.utc().valueOf()

        dispatch(REDUX_ACTIONS.v3_vamEntries.get_vam_entry_thru_timeframe_request({
            ...submitVal,
            startTime,
            endTime
        }))
    }

    return (
        <div className = "formField">

            <div className = "formField">
                <span className = "formFieldLabelLeft">Vehicles: </span>

                <TreeSelect 
                    allowClear
                    treeCheckable
                    showCheckedStrategy = {SHOW_PARENT}
                    placeholder = {Object.keys(vehicles).length ? 'Select Vehicles' : "No Vehicles Found"}
                    disabled = {!Object.keys(vehicles).length}
                    style={{ width: 175, maxHeight: 30, overflowY: 'auto', height: 30 }}
                    onChange = {value => {

                        const vids = value.includes('ALL') ? Object.keys(vehicles) : value.map(v => v.split('@')[1])

                        setSubmitVal(prev => ({ ...prev, vids }))
                    }}
                >
                    {
                        <TreeNode
                            key = {'ALL'}
                            value = {'ALL'}
                            title = {"All Vehicles"}
                        >
                            {
                                Object.values(vehicles)
                                .filter((currVehicle) => currVehicle.plate)
                                .sort((a, b) => {
                                    const vA = a.plate && a.plate.toLowerCase();
                                    const vB = b.plate && b.plate.toLowerCase();
                            
                                    if (vA < vB) return -1;
                                    if (vA > vB) return 1;
                                    return 0;
                                })
                                .map((currVehicle) => 
                                    <TreeNode
                                        key = {`${currVehicle.plate}@${currVehicle.vid}`}
                                        value = {`${currVehicle.plate}@${currVehicle.vid}`}
                                        title = {<VehiclePlateECUTag plate={currVehicle.plate} vehicle={vehicleECUValidator(vehicles[currVehicle.vid])}/>}
                                    />
                                )
                            }
                        </TreeNode>
                    }
                </TreeSelect>
            </div>
            <div className = "formField">
                <span className = "formFieldLabel">Line Type: </span>

                <Select
                    placeholder = {"Select a Line Type"}
                    style={{ height: '100%'}}
                    options={Object.values(vamLineTypes)?.map(vlty => ({ label: vlty.name, value: vlty.vamltyid }))}
                    onChange = {(value) => {
                        setSubmitVal(prev => ({ ...prev, lineTypes: [value] }))
                    }
                }
                />
            </div>
            <div className = "formField">
                <span className = "formFieldLabel">Status: </span>

                <Select
                    placeholder = {"Select a Status"}
                    options={Object.values(VAM_ENTRY_STATUS_TITLE)?.map(ves => ({ label: ves.name, value: ves.status}))}
                    onChange = {(value) => {
                        setSubmitVal(prev => ({ ...prev, statuses: [value] }))
                    }
                }
                />
            </div>
            <div className = "formField">
                <span className = "formFieldLabel">Timeframe: </span>

                <DatePicker.RangePicker
                    showTime
                    disabledDate={handleCalendarDisabledDate}
                    disabled={!Object.keys(vehicles)?.length}
                    value = {[dayJSLocalize(submitVal.startTime), dayJSLocalize(submitVal.endTime)]}
                    onChange = {(dates) => {
                        setSubmitVal(prev => ({
                            ...prev,
                            startTime: dates[0],
                            endTime: dates[1]
                        }))
                    }}
                    style = {{ width: '380px' }}
                />
            </div>
            <PrimaryButton color = '#F58C1E' onClick={submitFormHDLR}>Submit</PrimaryButton>
        </div>
    )
}

export default React.memo(SearchFields)